import { diContainer } from '@/coreContainer/container';
import { UserAccount } from '@/coreDomainsModule/entities/users';
import { LoadingState } from '@/coreDomainsModule/uiLoadingState';
import { defineStore } from 'pinia';
import { reactive } from 'vue';

/**
 * ユーザー情報のStoreを返す
 */
export const useUserStore = defineStore('user', () => {
  const state = reactive<IUserState>({
    userList: [],
    searchingUserList: [],
    selectedUserList: [],
    userListFetchState: { status: { type: 'none' } },
  });

  /**
   * Stateのリセット
   */
  const $reset = () => {
    state.userList = [];
    state.searchingUserList = [];
    state.selectedUserList = [];
    state.userListFetchState = { status: { type: 'none' } };
  };

  /**
   * 初期化
   */
  const init = async () => {
    $reset();
    await fetchUserList();
  };

  /**
   * ユーザー情報をフェッチする
   * @param keyword - ユーザー名検索キーワード
   */
  const fetchUserList = async (keyword?: string) => {
    state.userListFetchState = { status: { type: 'loading' } };
    const result = await diContainer.getAllUsersUseCase.execute(keyword);
    switch (result.status.type) {
      case 'success':
        if (!keyword) state.userList = result.status.data;
        state.searchingUserList = result.status.data;
        state.userListFetchState = result.status.data.length ? { status: { type: 'success' } } : { status: { type: 'zeroMatch' } };
        return;
      case 'error':
      default:
        console.error('ユーザー情報取得失敗', result?.status?.error ?? 'Unexpected error');
        state.userListFetchState = { status: { type: 'error', errorMessage: result?.status?.error.message ?? 'Unexpected error' } };
    }
  };

  return {
    state,
    $reset,
    init,
    fetchUserList,
  };
});

/**
 * ユーザー情報のStateのインターフェース
 */
interface IUserState {
  userList: UserAccount[];
  searchingUserList: UserAccount[];
  selectedUserList: UserAccount[];
  userListFetchState: LoadingState;
}
